import { InjectionToken, Signal } from '@angular/core';
import { KycPublic, KycStatusResponse } from '../domain/kyc-status.response';

export const KYC_STATUS = new InjectionToken<Signal<KycStatusResponse | null>>('KYC_STATUS');
export const KYC_PUBLIC = new InjectionToken<Signal<KycPublic | null>>('KYC_PUBLIC');
